module.exports = __webpack_public_path__ + "img/question-mark-icon-base.424d8efc.svg";